import type { Tile } from "./types";

export function isCannonTile(tile: Pick<Tile, "kind">): boolean {
  return tile.kind === "cannon";
}

export function blocksUnitOccupation(tile: Pick<Tile, "kind">): boolean {
  return isCannonTile(tile);
}
